/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * Directive for our activity feed.
 */
angular.module('bulbApp.activityModule')
  .directive('bulbActivityHeader', [bulbActivityHeader]);

function bulbActivityHeader() {
  return {
    restrict: 'E',
    templateUrl: 'ajs/components/activity/activityheader.html',
    controller: 'ActivityController as activityCtrl',
    link: function link(scope, element, attrs) {
      /**
       * The purpose of this watcher is purely for animating in new activities.
       *
       * FUTURE: switch to ngAnimate or some other tool once we have time to work on animations more.
       */
      scope.$watchCollection('activityCtrl.activityFeed.activities', (newVal, oldVal) => {
        // FUTURE: Amazingly, ng-move is not supported in this case., using jQuery temporarily, until we find a
        // better animation library.
        // see: https://github.com/angular/angular.js/issues/5160

        if (newVal === oldVal) {
          return;
        }

        // do not continue if there are no new values (happens during init)
        if (newVal.length === 0) {
          return;
        }

        // do not continue if we cannot see the activity feed
        if (!element.is(':visible')) {
          return;
        }
        let numNewActivities = newVal.findIndex((index) => index === oldVal[0]);

        if (numNewActivities === 0) {
          return;
        }

        if (numNewActivities < 0) {
          numNewActivities = 99;
        }

        const containerElement = element.find('.bulb-activity-container .bulb-scroll-content');

        const animateHeight = jQuery(element.find('.bulb-activity')[numNewActivities]).position().top;

        containerElement.css('top', `-${animateHeight}px`);
        containerElement.css('position', 'relative');
        containerElement.animate({ top: '0', position: 'auto' }, 1000);
      });
    },
  };
}
